var View = require('views/base/view');
var Const = require('lib/const');
var Model = require('models/formData');
var Calcul = require('lib/calculMadelin');

module.exports = View.extend({
  autoRender: true,
  className: 'home-page',
  template: require('./templates/home'),

  initialize: function() {
    this.model = this.model || new Model();
    $('body').on('mouseup', this.hideDetails);
  },

  events: {
    'change #inputBenefImp': 'changeBenefice',
    'change #inputCotisRet': function() { this.changeCotis('cotisRet','#inputCotisRet'); },
    'change #inputCotisPrev': function() { this.changeCotis('cotisPrev','#inputCotisPrev'); },
    'change #inputCotisChom': function() { this.changeCotis('cotisChom','#inputCotisChom'); },
    'change #inputCotisMens': 'changeCotisMens',
    'change #CB_TMI': 'changeTmi',
    'click #btnReinit': 'razSimu',
    'click #btnPrint': 'printResult'
  },

  listen: {
    //'change model': 'render'
  },

  getTemplateData: function() {
    return {
      anneeRef: Const.constantes._YEAR,
      benefImp: this.model.get('benefImp'),
      cotisRet: this.model.get('cotisRet'),
      cotisPrev: this.model.get('cotisPrev'),
      cotisChom: this.model.get('cotisChom'),
      cotisMens: this.model.get('cotisMens'),
      versMaxRet: Calcul.cotisRetFalcMax(),
      versMaxPrev: Calcul.cotisPrevComMax(),
      versMaxChom: Calcul.cotisChomMax(),
      versLimRet: this.model.get('versLimRet'),
      versLimPrev: this.model.get('versLimPrev'),
      versLimChom: this.model.get('versLimChom'),
      cotisRetSolde: this.model.get('cotisRetSolde'),
      cotisPrevSolde: this.model.get('cotisPrevSolde'),
      cotisChomSolde: this.model.get('cotisChomSolde'),
      cotisMaxMens: this.model.get('cotisMaxMens'),
      cotisAnnuel: this.model.get('cotisAnnuel'),
      ecoImpEstime: this.model.get('ecoImpEstime'),
      tmi: this.model.get('tmi')
    };
  },

  afterRender: function() {
    var PASS = accounting.formatMoney(Const.constantes._PASS, {format:'%v %s'});
    this.$('#infoVersMaxRet').popover({
      html: true,
      placement: 'top',
      title: 'Cotisations de retraite facultative',
      content: '(10 % x 8 x PASS) + (15 % x 7 x PASS) <br/><span><small>PASS: Plafond Annuel de la Sécurité Sociale <span class="text-nowrap">' + PASS + '</span></small></span>'
    });
    this.$('#infoVersMaxPrev').popover({
      html: true,
      placement: 'top',
      title: 'Cotisations de prévoyance facultative',
      content: '(3 % x 8 x PASS)<br/><span><small>PASS: Plafond Annuel de la Sécurité Sociale <span class="text-nowrap">' + PASS + '</span></small></span>'
    });
    this.$('#infoVersMaxChom').popover({
      html: true,
      placement: 'top',
      title: 'Cotisations de perte d\'emploi',
      content: '(1,875 % x 8 x PASS)<br/><span><small>PASS: Plafond Annuel de la Sécurité Sociale <span class="text-nowrap">' + PASS + '</span></small></span>'
    });
    this.$('#infoVersLimRet').popover({
      html: true,
      placement: 'left',
      title: 'Cotisations de retraite facultative: La plus élevée des deux limites',
      content: '<ul><li>(10 % x bénéfice imposable plafonné à 8 fois le PASS) + (15 % x fraction du bénéfice imposable supérieure au PASS prise dans la limite de 7 fois le PASS),</li><li>ou (10 % x PASS)</li></ul><span><small>PASS: Plafond Annuel de la Sécurité Sociale <span class="text-nowrap">' + PASS + '</span></small></span>'
    });
    this.$('#infoVersLimPrev').popover({
      html: true,
      placement: 'left',
      title: 'Cotisations de prévoyance complémentaire: Double limite',
      content: '<ul><li>(7 % x PASS) + (3,75 % x bénéfice imposable),</li><li>et (3 % x 8 x PASS)</li></ul><span><small>PASS: Plafond Annuel de la Sécurité Sociale <span class="text-nowrap">' + PASS + '</span></small></span>'
    });
    this.$('#infoVersLimChom').popover({
      html: true,
      placement: 'left',
      title: 'Cotisations de perte d\'emploi: La plus élevée des deux limites',
      content: '<ul><li>(2,5 % x PASS)</li><li>ou (1,875 % x bénéfice imposable plafonnée à 8 fois le PASS)</li></ul><span><small>PASS: Plafond Annuel de la Sécurité Sociale <span class="text-nowrap">' + PASS + '</span></small></span>'
    });
  },

  render: function() {
    View.prototype.render.apply(this, arguments);
    var select = this.$('#CB_TMI'); // scope of this changes within 'each' (refers to same thing as the 'model' argument)
    var tmi = this.model.get('tmi');
    //var tmi = '0.41';
    var frag = '';
    var option, selected;

    _.each(Const.listTmi, function(model){
        selected = (tmi === model.value) ?  ' selected' : '' ;
        option = '<option value="' + model.value + '"' + selected +' >' + model.label + '</option>';
        frag += option;
    }, this);

    // We could of had the 'append' calls within the loop
    // but that would have meant multiple DOM interactions
    select.append(frag);
  },

  changeBenefice: function() {
    this.model.set('benefImp',accounting.unformat(this.$('#inputBenefImp').val()));

    this.model.set('versLimRet',Calcul.cotisRetFalc(this.model.get('benefImp')));
    this.model.set('versLimPrev',Calcul.cotisPrevFalc(this.model.get('benefImp')));
    this.model.set('versLimChom',Calcul.cotisChomFalc(this.model.get('benefImp')));
    this.changeSolde();

    this.render();
  },

  changeSolde: function() {
    this.model.set('cotisRet', Math.min(this.model.get('versLimRet'), (this.model.get('cotisRet') || 0)));
    this.model.set('cotisRetSolde',this.model.get('versLimRet') - this.model.get('cotisRet'));

    this.model.set('cotisPrev', Math.min(this.model.get('versLimPrev'), (this.model.get('cotisPrev') || 0)));
    this.model.set('cotisPrevSolde',this.model.get('versLimPrev') - this.model.get('cotisPrev'));

    this.model.set('cotisChom', Math.min(this.model.get('versLimChom'), (this.model.get('cotisChom') || 0)));
    this.model.set('cotisChomSolde',this.model.get('versLimChom') - this.model.get('cotisChom'));

    this.calcMaxMens();
    this.changeCotisMens();
  },

  changeCotis: function(dataAttr, domAttr) {
    this.model.set(dataAttr,accounting.unformat(this.$(domAttr).val()));

    this.changeSolde();
    this.render();
  },

  calcMaxMens: function() {
    var totalMaxMens = 0,
      ret = this.model.get('cotisRetSolde'),
      prev = this.model.get('cotisPrevSolde'),
      chom = this.model.get('cotisChomSolde');

      totalMaxMens = (ret + prev + chom) / 12;

      this.model.set('cotisMaxMens', totalMaxMens);
  },

  changeCotisMens: function() {
    this.model.set('cotisMens', Math.min(this.model.get('cotisMaxMens'),accounting.unformat(this.$('#inputCotisMens').val())));

    this.model.set('cotisAnnuel',this.model.get('cotisMens')*12);

    this.calculEcoImp();

    this.render();
  },

  changeTmi: function() {
    this.model.set('tmi',this.$('option:selected','#CB_TMI').val());

    this.calculEcoImp();

    this.render();
  },

  calculEcoImp: function() {
    var tmi = this.model.get('tmi');
    var cotis = this.model.get('cotisAnnuel');

    this.model.set('ecoImpEstime', tmi*cotis);
  },

  razSimu: function() {
    this.model.clear();
    this.render();
  },

  printResult: function () {
    window.print()
  }
});
